import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { EnaioLearnService } from '../../services/enaio-learn.service';

@Component({
    selector: 'app-learning-admin',
    templateUrl: './learning-admin.component.html',
    styleUrls: ['./learning-admin.component.scss']
})
export class LearningAdminComponent extends ComponentView {

    service = inject(EnaioLearnService);

    isAdmin = false;

    async initParams(): Promise<boolean> {
        this.isAdmin = (await this.service.getMyProfile()).isAdmin;
        this.service.updateNavigation(null, [{ label: this.app.t("lea.admin.title"), routerLink: ["/enaio-learn", "admin"]}]);
        return Promise.resolve(true);
    }
}
